import { PATHNAMES } from "../components/constants/pathNameConstants";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../utils/config";

const getCsrfToken = async () => {
  try {
    // Call consumer services for CSRF Token
    const csrfTokenResponse = await axios.get(
      `${API_BASE_URL}/csrf-token/v1/token`,
      {
        withCredentials: true,
      },
    );

    // Pull csrf token from response header and return
    return csrfTokenResponse.headers["x-csrf-token"];
  } catch (error) {
    return Promise.reject(new Error("Failed to fetch CSRF token"));
  }
};

export const isTokenExpired = () => {
  const token = localStorage.getItem("consumerSite_token");
  if (token) {
    const { exp } = jwtDecode(token);
    const expirationTime = exp * 1000;
    const currentTime = Date.now();
    return currentTime > expirationTime;
  } else {
    return false;
  }
};

export const isResetTokenExpired = (token) => {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    const expirationTime = exp * 1000;
    return Date.now() > expirationTime;
  } catch {
    return true;
  }
};

// const setToken = () => {
axios.interceptors.request.use(
  async (config) => {
    try {
      if (isTokenExpired()) {
        window.location.href = PATHNAMES.VEHICLEHISTORY_LOGIN;
        sessionStorage.setItem("isSessionExpired", true);
        return Promise.reject(
          "Invalid or expired token. Redirecting to login.",
        );
      }

      // Add Authorization token if available
      const token = localStorage.getItem("consumerSite_token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      if (config.method !== "get")
        config.headers["X-CSRF-TOKEN"] = await getCsrfToken();
      // config.headers["X-CSRF-TOKEN"] =
      //   "QGJVKa5xJWwJ5gzjNGN1VUo2PHjcR28HEzgogb6EpnKG42mEdFBnH55HEVQkgzXWVk5BYXsHERm4dlcqIg5OuNyxnxGz0w3m";
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default getCsrfToken;
